import { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { EntityContext } from '../../entity';
import Loading from '../loading';

function dashboardPathAllowsLimitedMode(pathname) {
  if (pathname === '/dashboard' || pathname === '/dashboard/') return true;
  if (pathname === '/dashboard/entities' || pathname.startsWith('/dashboard/entities/')) return true;
  if (pathname === '/dashboard/entity' || pathname.startsWith('/dashboard/entity/')) return true;
  if (pathname === '/dashboard/pendingSignatures' || pathname.startsWith('/dashboard/pendingSignatures/'))
    return true;
  if (pathname === '/dashboard/my-signatures' || pathname.startsWith('/dashboard/my-signatures/'))
    return true;
  return false;
}

export default function DashboardPlanGate() {
  const location = useLocation();
  const { entity, entityHasActivePlan, entityPlanStatusLoading } = useContext(EntityContext);

  if (!entity || typeof entity !== 'object' || !entity.api_key) {
    return <Outlet />;
  }

  if (entityPlanStatusLoading) {
    if (dashboardPathAllowsLimitedMode(location.pathname)) {
      return <Outlet />;
    }
    return <Loading />;
  }

  if (entityHasActivePlan !== false) {
    return <Outlet />;
  }

  if (dashboardPathAllowsLimitedMode(location.pathname)) {
    return <Outlet />;
  }

  return <Navigate to="/dashboard/pendingSignatures" replace />;
}
